import { ClubCode } from './enum';

export enum ModuleMode {
  Monitor = 'monitor',
  ActiveBlocking = 'active_blocking',
}

export interface IBotDetectionParameters {
  enabled: boolean;
  sensitive: boolean;
  clubs?: {
    [clubCode: string]: ModuleMode;
  };
}
